// Pipe: return string for string input, and normalized array for array input
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'internalRoute', pure: true })
export class InternalRoutePipe implements PipeTransform {
  transform(route: unknown): string | any[] | null {
    if (!route) return null;

    const isExternal = (s: string) =>
      /^([a-z0-9+\-.]+:)?\/\//i.test(s) || /^[a-z0-9+\-.]+:/i.test(s);

    // String input → return string as-is (relative segment), unless external
    if (typeof route === 'string') {
      if (isExternal(route)) return null;
      return route; // "create" stays "create" (not ["create"])
    }

    // Array input → normalize segments
    if (Array.isArray(route) && route.length > 0) {
      const copy = [...route];
      const first = copy[0];
      if (typeof first === 'string' && isExternal(first)) return null;

      for (let i = 1; i < copy.length; i++) {
        const seg = copy[i];
        if (typeof seg === 'string' && seg.startsWith('/')) copy[i] = seg.slice(1);
      }
      return copy as any[];
    }

    return route as any[] | null;
  }
}
